import service from "@/utils/request";

// 地址库
export interface getAdressInter {
  pid?: number;
}
export const getAdressApi = (params: getAdressInter) => {
  return service({
    url: "/api/v1/address/list",
    method: "get",
    params,
  });
};
